export const MANUAL_CPC = {
  key: 'manualCpc',
  text: _TL_('Manual CPC'),
  type: 'ManualCpc',
};

export const MANUAL_CPC_SCHEMA = {
  name: 'Product Schema',
  type: 'object',
  properties: {},
};
